import { useSelector } from 'react-redux';
import { AppState } from '../store/AppState';
import { AuthState } from '../store/identity/AuthSlice';

export const useUser = (): useUserReturnType => {
  const authState = useSelector<AppState, AuthState>((state) => state.auth);

  return {
    user: authState.user,
    isLoadingUser: authState.isLoadingUser,
    isExpiredUser: authState.isExpiredUser,
    isErrorUser: authState.isErrorUser,
  };
};

export type useUserReturnType = {
  user: string;
  isLoadingUser: boolean;

  // Not really necessary to have these two properties
  isExpiredUser: boolean;
  isErrorUser: boolean;
};